var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" +"+_vm._s(_vm._f("number")(_vm.percentual,'0.00'))+"% de IPI "),_c('b',[_vm._v("não incluso")]),_c('px-oferta-imposto-nao-incluso-menu',{attrs:{"oferta":_vm.oferta,"variacao":_vm.variacao}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }